<template>
    <li class="has-sub">
        <a href="javascript:;">
            <b class="caret pull-right"></b>
            <i class="fa fa-money"></i>
            <span>Pembayaran</span>
        </a>

        <ul class="sub-menu">
            <li>
                <router-link to="/produk">Paket</router-link>
            </li>
            <li>
                <router-link to="/jadwal-kelas">Jadwal Kelas</router-link>
            </li>
            <li>
                <router-link to="/transaksi">Transaksi</router-link>
            </li>
        </ul>
    </li>
</template>

<script>
export default {
    name: "pembayaran-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?4380fe7a